import { SLA_LIMITS } from "@sagot/constants";
import type { SlaPolicy, SlaPolicyInput } from "../shared";

/** The dialog's fields; an unset optional target is `null`. */
export type SlaDraft = SlaPolicyInput;

export const emptySlaDraft = (): SlaDraft => ({
  name: "",
  first_response_minutes: SLA_LIMITS.firstResponseDefault,
  next_response_minutes: null,
  resolution_minutes: null,
  office_hours_only: false,
  warn_before_minutes: SLA_LIMITS.warnDefault,
});

export const slaDraftOf = (policy: SlaPolicy): SlaDraft => ({
  name: policy.name,
  first_response_minutes: policy.first_response_minutes,
  next_response_minutes: policy.next_response_minutes,
  resolution_minutes: policy.resolution_minutes,
  office_hours_only: policy.office_hours_only,
  warn_before_minutes: policy.warn_before_minutes,
});

export type SlaProblem = "name" | "warn";

/** The shortest target of the policy: a warning has to come earlier than that. */
export function shortestTarget(draft: SlaDraft): number {
  return Math.min(...[draft.first_response_minutes, draft.next_response_minutes, draft.resolution_minutes].filter((minutes): minutes is number => minutes !== null));
}

export function slaProblems(draft: SlaDraft): Set<SlaProblem> {
  const problems = new Set<SlaProblem>();
  if (!draft.name.trim()) problems.add("name");
  if (draft.warn_before_minutes >= shortestTarget(draft)) problems.add("warn");
  return problems;
}

export const slaBodyOf = (draft: SlaDraft): SlaPolicyInput => ({ ...draft, name: draft.name.trim() });
